import { useState, useEffect, RefObject } from 'react'

const useElementVisible = (ref: RefObject<HTMLElement>, threshold: number = 0.1) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const checkVisibility = () => {
      if (!ref.current) return
      const { offsetTop } = ref.current
      const scrollY = window.pageYOffset
      const windowHeight = window.innerHeight

      if (scrollY > offsetTop - windowHeight + windowHeight * threshold) {
        setIsVisible(true)
      }
    }

    window.addEventListener('scroll', checkVisibility)
    window.addEventListener('resize', checkVisibility)
    checkVisibility()

    return () => {
      window.removeEventListener('scroll', checkVisibility)
      window.removeEventListener('resize', checkVisibility)
    }
  }, [ref, threshold])

  return isVisible
}

export default useElementVisible
